// OrderDetailsSection.jsx
import React from 'react';
import TableNumberField from './TableNumberField';
import EmailField from './EmailField';
export const OrderDetailsSection = ({
  orderType,
  onSwitchOrderType,
  onUpdateEmail,
  isLoading,
}) => {
  return (
    <div className="flex flex-col">
      {orderType === 'dine_in' && (
        <TableNumberField onSwitch={onSwitchOrderType} />
      )}

      <EmailField onClick={onUpdateEmail} callback={onUpdateEmail} />
    </div>
  );
};
